import {Box, BoxProps, Heading, HStack, Stack, StackProps} from "@chakra-ui/react";
import {
  HoverMenuItem,
  HoverMenuItemHeading,
  HoverMenuItemText,
  HoverMenuList,
  HoverMenuSection,
  HoverMenuSeparator,
} from "../components/HoverMenu";
import {ReactNode} from "react";
import {Logo} from "../../Logo";

const AppIcon = ({size = "md", ...props}: {size?: "sm" | "md" | "lg"} & BoxProps) => {
  const w = {
    sm: 6,
    md: 8,
    lg: 12,
  }[size];

  const p = {
    sm: 1,
    md: 1.5,
    lg: 3,
  }[size];

  return (
    <Box w={w} h={w} p={p} rounded={size} flexShrink={0} {...props}>
      <Logo light w="full" h="full" />
    </Box>
  );
};

const App = ({icon, name, about, to}: {icon: ReactNode; name: string; about: string; to: string}) => (
  <HoverMenuItem className="group">
    {icon}
    <Stack gap={1}>
      <HoverMenuItemHeading to={to}>{name}</HoverMenuItemHeading>
      <HoverMenuItemText>{about}</HoverMenuItemText>
    </Stack>
  </HoverMenuItem>
);

const SectionHeading = ({children}: {children: ReactNode}) => (
  <HStack gap={1}>
    <Heading color="gray.400" size="xs" textTransform="uppercase">
      For
    </Heading>
    <Heading size="xs" textTransform="uppercase">
      {children}
    </Heading>
  </HStack>
);

const Solutions = (props: StackProps) => (
  <HoverMenuList {...props}>
    <Stack separator={<HoverMenuSeparator />} gap={4}>
      <HoverMenuSection heading={<SectionHeading>External Audit</SectionHeading>}>
        <App
          icon={<AppIcon bgGradient="blueBrand" />}
          name="Financial Audit"
          about="Automate risk &amp; control assurance for external audits"
          to="/financial-audit"
        />
        {/*<App
          icon={<AppIcon bgGradient="blueBrand" />}
          name="IT Audit"
          about="Streamline SOC 2, ISO 27001, &amp; internal control testing"
          to="/it-audit"
        />*/}
        <App
          icon={<AppIcon bgGradient="blueBrand" />}
          name="Vendor Risk Management"
          about="AI-powered assurance across your digital supply chain"
          to="/vrm"
        />
      </HoverMenuSection>
      <HoverMenuSection heading={<SectionHeading>Sales teams</SectionHeading>}>
        <App
          icon={<AppIcon bgGradient="showcase" />}
          name="Customer Assurance"
          about="Respond faster to DDQs, RFPs, &amp; compliance reviews"
          to="/customer-assurance"
        />
      </HoverMenuSection>
    </Stack>
  </HoverMenuList>
);

export default Solutions;
